module.exports = __webpack_public_path__ + "media/SetA_L1_A_twice.84649ca6.mp3";